import React, { MouseEventHandler } from "react";
import { FaThumbsUp, FaComment, FaShareAlt, FaEye } from "react-icons/fa"; // New icons

interface IReaction {
  title: string;
  value?: string | number; // Assuming string from Feed, could be number
  logo?: React.ReactNode; // Optional, as we'll set defaults
  isDark?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

const Reaction: React.FC<IReaction> = ({
  title,
  value,
  logo,
  isDark,
  onClick,
}) => {
  // Default icons based on title
  const defaultIcons: { [key: string]: React.ReactNode } = {
    Like: (
      <FaThumbsUp className="w-5 h-5 text-indigo-600 dark:text-indigo-400" />
    ),
    Comment: <FaComment className="w-5 h-5 text-gray-600 dark:text-gray-400" />,
    Share: <FaShareAlt className="w-5 h-5 text-gray-600 dark:text-gray-400" />,
    Views: <FaEye className="w-5 h-5 text-gray-600 dark:text-gray-400" />,
  };

  const displayIcon = logo || defaultIcons[title] || null;

  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-2 px-3 py-1 rounded-md text-sm font-medium transition-colors duration-200 ${
        isDark
          ? "text-gray-400 hover:bg-gray-100 hover:text-deepBg"
          : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
      }`}
      aria-label={`${title} (${value})`}
    >
      {displayIcon}
      <span>{value || "0"}</span>
      <span className="hidden sm:inline">{title}</span>
    </button>
  );
};

export default Reaction;
